import Cookies from 'js-cookie'
import { getData } from 'src/helper'
import { getStoredUser } from './roles'

export const getTokenPayload = () => {
  try {
    const token = Cookies.get('token')
    if (!token) return null

    const payloadPart = token.split('.')[1]
    if (!payloadPart) return null

    return JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return null
  }
}

export const isTokenValid = () => {
  const token = Cookies.get('token')
  const payload = getTokenPayload()

  if (!token || !payload?.user_id) return false
  if (payload.exp && payload.exp * 1000 <= Date.now()) return false

  return true
}

export const getAuthenticatedUserId = () => {
  const user = getStoredUser()
  const fromUser = Number(user?.id ?? user?.user_id)
  if (Number.isFinite(fromUser) && fromUser > 0) return fromUser

  const fromToken = Number(getTokenPayload()?.user_id)
  return Number.isFinite(fromToken) && fromToken > 0 ? fromToken : null
}

export const resolveUserDisplayName = (user = getStoredUser()) => {
  const candidates = [
    user?.namear,
    user?.name_ar,
    user?.nameen,
    user?.name_en,
    user?.student_namear,
    user?.student_name,
    user?.name,
    user?.username,
    user?.user_name,
    user?.email,
  ]

  for (const value of candidates) {
    const text = String(value ?? '').trim()
    if (text) return text
  }

  return null
}

export const getUserDisplayName = (user = getStoredUser()) =>
  resolveUserDisplayName(user) || 'المستخدم'

export const fetchAndCacheUserProfile = async () => {
  if (!isTokenValid()) return null

  try {
    const res = await getData('my-user', null, { skipLoading: true })
    if (!res?.success || !res?.data) return null

    const profile = res.data
    const current = getStoredUser() || {}
    const merged = {
      ...current,
      ...profile,
      id: profile.id ?? current.id ?? getAuthenticatedUserId(),
      user_id: profile.id ?? current.user_id ?? getAuthenticatedUserId(),
      role_id: profile.role_id ?? current.role_id,
      namear: profile.namear ?? current.namear,
      nameen: profile.nameen ?? current.nameen,
      ...(profile.student_id != null ? { student_id: profile.student_id } : {}),
      ...(profile.has_pleged != null ? { has_pleged: profile.has_pleged } : {}),
      ...(profile.commencement_badge != null
        ? { commencement_badge: profile.commencement_badge }
        : {}),
      ...(profile.group_id != null ? { group_id: profile.group_id } : {}),
      ...(profile.group_name != null ? { group_name: profile.group_name } : {}),
      ...(profile.parent_group_name != null
        ? { parent_group_name: profile.parent_group_name }
        : {}),
      ...(profile.shift_request != null ? { shift_request: profile.shift_request } : {}),
      ...(profile.gender_id != null ? { gender_id: profile.gender_id } : {}),
    }

    Cookies.set('user_data', JSON.stringify(merged), { expires: 90 })
    localStorage.setItem('userData', JSON.stringify(merged))

    return merged
  } catch (error) {
    console.error('Failed to load user profile:', error)
    return null
  }
}
